<app-hero data-test="newsroom-hero-section" [config]="heroConfig"></app-hero>
<app-pagination
  [totalItems]="allArticles.length"
  [itemsPerPage]="articlesPerPage"
  [allArticles]="allArticles"
></app-pagination>
<app-job-offers></app-job-offers>
<app-contact-form [config]="CEO_CONFIG"></app-contact-form>
